export default {
  datasourcesInternal: [
    {
      label: 'datasources.routes.questions',
      action: 'route:change',
      payload: { route: 'questions' },
      indexName: 'questions',
    },
    {
      label: 'datasources.routes.viewResponses',
      action: 'route:change',
      payload: { route: 'responses' },
      indexName: 'view-responses',
    },
  ],
};
